import { useQueryGet } from "@/typed-client/hooks/use-query-get"

export function useReminderPermission(reminderId: number) {
  const { data, isLoading, error } = useQueryGet(
    "/api/Reminder/GetReminderPermission",
    { reminderId },
    { enabled: !!reminderId }
  )

  return {
    permission: data ?? "No",
    isLoading,
    error,
  }
}
